<ng-container *ngIf="slides.length">
  <app-image-loading *ngIf="isServer; else client"
                     [id]="slideIds"
                     [src]="slides[0].hash"
                     [alt]="slides[0].alt"
                     [middle]="true"
                     [clickable]="true"
                     [originalQuality]="true"
                     [priority]="true"
                     [widthCss]="widthCss"
                     [targetWidth]="width()"
                     [targetHeight]="targetHeight()"/>
  <ng-template #client>
    @if (slides.length) {
      <div class="relative">
        <swiper-container appSwiper class="lativ-swiper" init="false" #swiper
                          [class.small-bullet]="smallBullet"
                          [class.hide-bullet]="hideBullet"
                          [style.height.px]="targetHeight()"
                          [config]="config">
          <swiper-slide *ngFor="let slide of slides; trackBy: trackByFn; let first = first">
            <button appFocusRemove (click)="onClick(slide)">
              <app-image-loading [src]="slide.hash"
                                 [alt]="slide.alt"
                                 [clickable]="true"
                                 [originalQuality]="true"
                                 [priority]="first"
                                 [targetWidth]="width()"
                                 [targetHeight]="targetHeight()"/>
            </button>
          </swiper-slide>
        </swiper-container>
        <button class="prev-btn" (click)="onPrev()">
        </button>
        <button class="next-btn" (click)="onNext()">
        </button>
      </div>
    }
  </ng-template>
</ng-container>
